import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './admin/admin.component';
import { BookAppointmentComponent } from './homepage/book-appointment/book-appointment.component';
import { HomepageComponent } from './homepage/homepage.component';
import { SuccessComponent } from './homepage/success/success.component';
//Ecademin
import { EcaadminLoginComponent } from './ecaadmin-login/ecaadmin-login.component';
import {EcasubAdminDashboardComponent} from './ecasub-admin-dashboard/ecasub-admin-dashboard.component';
import { AuthGuard } from '../app/ecaservice/Auth.guard';
import { EcaadminDashboardComponent } from './ecaadmin-dashboard/ecaadmin-dashboard.component';
import { ContactUsComponent } from './homepage/contact-us/contact-us.component';
import { TermsAndConditionsComponent } from './homepage/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './homepage/privacy-policy/privacy-policy.component';
import { CancellationPolicyComponent } from './homepage/cancellation-policy/cancellation-policy.component';
const routes: Routes = [
  {
    path: '',
    component: HomepageComponent
  },
  {
    path:'admin',
    component: AdminComponent
  },
  {
    path:'contact-us',
    component: ContactUsComponent
  },
  {
    path:'terms-and-conditions',
    component: TermsAndConditionsComponent
  },
  {
    path:'privacy-policy',
    component: PrivacyPolicyComponent
  },
  {
    path:'cancellation-policy',
    component: CancellationPolicyComponent
  },
  {
    path:'book',
    component: BookAppointmentComponent
  },
  {
    path:'success/:id',
    component:SuccessComponent
  },

  //Ecademic
  {
    path: 'ecademic/admin',
    component: EcaadminDashboardComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'ecademic/sub-admin',
    component: EcasubAdminDashboardComponent,
    canActivate:[AuthGuard]
  },

  {
    path: 'ecademic/login',
    component: EcaadminLoginComponent
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
